import { RxExternalLink } from "react-icons/rx";

const AnimatedProductCard = ({ title, description, image, link }) => {
  return (
    <div className="group relative overflow-hidden rounded-xl backdrop-blur-sm bg-card p-4 transition-all bg-[#ffffff0e] duration-300 hover:scale-[1.02] hover:shadow-xl">
      <div className="aspect-video w-full overflow-hidden rounded-lg">
        <img
          src={image}
          alt={title}
          className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-110"
        />
      </div>
      <div className="mt-4">
        <div className="flex items-center justify-between">
          <h3 className="font-mono text-xl font-bold text-white">{title}</h3>
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary-foreground opacity-0 transition-opacity duration-300 group-hover:opacity-100"
          >
            <RxExternalLink className="h-5 w-5 text-white" />
          </a>
        </div>
        <p className="mt-2 text-sm text-gray-300">{description}</p>
      </div>
    </div>
  );
};

export default AnimatedProductCard;
